import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import StepHeader from "./StepHeader.js";
import { PanelParentMixin } from "../../mixins/panel.js";
import DarkMixin from "../../mixins/dark.js";
import { slot, mergeSlot } from "../../utils/slot.js";
import { stop } from "../../utils/event.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'QStepper',
  provide: function provide() {
    return {
      stepper: this
    };
  },
  mixins: [DarkMixin, PanelParentMixin],
  props: {
    flat: Boolean,
    bordered: Boolean,
    alternativeLabels: Boolean,
    headerNav: Boolean,
    contracted: Boolean,
    headerClass: String,
    inactiveColor: String,
    inactiveIcon: String,
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String
  },
  computed: {
    classes: function classes() {
      return "q-stepper q-stepper--".concat(this.vertical === true ? 'vertical' : 'horizontal') + (this.flat === true || this.isDark === true ? ' q-stepper--flat no-shadow' : '') + (this.bordered === true || this.isDark === true && this.flat === false ? ' q-stepper--bordered' : '') + (this.contracted === true ? ' q-stepper--contracted' : '') + (this.isDark === true ? ' q-stepper--dark q-dark' : '');
    },
    headerClasses: function headerClasses() {
      return 'q-stepper__header row items-stretch justify-between' + " q-stepper__header--".concat(this.alternativeLabels === true ? 'alternative' : 'standard', "-labels") + (this.flat === false || this.bordered === true ? ' q-stepper__header--border' : '') + (this.headerClass !== void 0 ? " ".concat(this.headerClass) : '');
    }
  },
  methods: {
    __getContent: function __getContent(h) {
      var _this = this;

      var top = slot(this, 'message', []);

      if (this.vertical === true) {
        this.__isValidPanelName(this.value) && this.__updatePanelIndex();
        var content = h('div', {
          staticClass: 'q-stepper__content',
          // stop propagation of content emitted @input
          // which would tamper with Panel's model
          on: cache(this, 'stop', {
            input: stop
          })
        }, slot(this, 'default'));
        return top === void 0 ? [content] : top.concat(content);
      }

      return [h('div', {
        class: this.headerClasses
      }, this.panels.map(function (panel) {
        var step = panel.componentOptions.propsData;
        return h(StepHeader, {
          key: step.name,
          props: {
            stepper: _this,
            step: step
          }
        });
      }))].concat(top, h('div', {
        staticClass: 'q-stepper__content q-panel-parent',
        directives: this.panelDirectives
      }, this.__getPanelContent(h)));
    },
    __renderPanels: function __renderPanels(h) {
      return h('div', {
        class: this.classes,
        on: _objectSpread({}, this.qListeners)
      }, mergeSlot(this.__getContent(h), this, 'navigation'));
    }
  }
});